import React from 'react';
import MainGrid from '../components/MainGrid';

export default function Overview() {
  return <MainGrid />;
}
